import React from 'react';
import PropTypes from 'prop-types';
import { useSort, useFilter } from '../Hooks';
import { isDev, und } from '../Utils';
import { Filter } from './Filter';
export const Column = ({ label, dataIndex, ...rest }) => {
	const { sortable, sortOrder, handleSort } = useSort(dataIndex);
	const { filterable } = useFilter(dataIndex);
	return (
		<th
			data-reatable='column'
			data-sortable={sortable || und}
			data-sort-order={sortable ? sortOrder || 'none' : und}
			data-filterable={filterable || und}
			{...rest}>
			<div className='rt-column'>
				{sortable ? (
					<span className='rt-sortable' onClick={handleSort}>
						{label}

						<i className='rt-sort-icon' />
					</span>
				) : (
					label
				)}
				{filterable && <Filter dataIndex={dataIndex} />}
			</div>
			<div className='rt-column-hidden'>{label}</div>
		</th>
	);
};

if (isDev) {
	Column.propTypes = {
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
			.isRequired,
		dataIndex: PropTypes.string,
	};
}
